import React from "react";
import { Navigate, Outlet } from "react-router-dom";

const ProtectedRoutes = () => {
    const auth = JSON.parse(sessionStorage.getItem("user"))
    return (
        auth ? <Outlet /> : <Navigate to="/login" />
    )
}
export default ProtectedRoutes;
